import type { FaireProductEntity } from "../../entity_types/product";

export const p_f44t6ebn4u: FaireProductEntity = {
  token: "p_f44t6ebn4u",
  type: "product",
  name: "rocky's matcha Single Cultivar Okumidori Matcha 20g",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/b4ae5b33b8a0e0cd088a7a775208c45c30b52b100c014f038a413285f3b74d6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4becf74e738ef187974b312641ef81391c169416d8f8ff17f660a5f799b5ba03.jpeg",
    "https://cdn.faire.com/fastly/e862599e62d5cf3de60cd5866e0e25b79606f632bd7a227acd8d8f277ab8a70e.jpeg",
    "https://cdn.faire.com/fastly/9badfd7fabec2ac69b82aee310fff5ccfee21928c7d3bd9d3359adc3d25b4151.jpeg"
  ],
  priceDollars: 14,
  description: "Experience the exquisite taste of rocky's matcha's single cultivar Okumidori matcha, sourced from the renowned Osada Tea in Shizuoka, Japan. This vibrant emerald green matcha has a fitting name given Okumidori means \"Deep Green\"; and is perfect for Koicha (thick) style matcha lovers. Elevate your taste buds with this premium quality matcha.\n\n\n\n+ Single Cultivar Okumidori Matcha\n\n+ Ceremonial Grade\n\n+ Cultivar: Okumidori\n\n+ Region: Shizuoka, Japan\n\n+ Net Weight: 20g\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:20.096Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
